import { gql } from '@apollo/client';

export const fetchShipToPartyForWidgetInPPC = gql`
  query fetchShipToPartyForWidgetInPPC($id: ID!, $shipToPartyOptions: ShipToPartyOptions) {
    transactionAccount(id: $id) {
      shipToParty(shipToPartyOptions: $shipToPartyOptions) {
        nodes {
          name
          id
          addressLine1
          addressLine2
          city
          state
          country
          postcode
        }
      }
    }
  }
`;
